const Share = () => {
  return (
    <svg width="14" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".398"
        d="M8.556 0 14 5.6l-5.444 5.6V7.92C4.666 7.92 1.944 9.2 0 12c.778-4 3.111-8 8.556-8.8V0Z"
        fill="#fff"
      />
    </svg>
  );
};
export default Share;
